module.exports = __webpack_public_path__ + "img/philippine.51650446.png";